import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './session.reducer';

export const SessionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const sessionEntity = useAppSelector(state => state.session.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="sessionDetailsHeading">
          <Translate contentKey="cabmanApp.session.detail.title">Session</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{sessionEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="cabmanApp.session.status">Status</Translate>
            </span>
          </dt>
          <dd>{sessionEntity.status}</dd>
          <dt>
            <span id="startDateTime">
              <Translate contentKey="cabmanApp.session.startDateTime">Start Date Time</Translate>
            </span>
          </dt>
          <dd>
            {sessionEntity.startDateTime ? <TextFormat value={sessionEntity.startDateTime} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="endDateTime">
              <Translate contentKey="cabmanApp.session.endDateTime">End Date Time</Translate>
            </span>
          </dt>
          <dd>
            {sessionEntity.endDateTime ? <TextFormat value={sessionEntity.endDateTime} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <Translate contentKey="cabmanApp.session.station">Station</Translate>
          </dt>
          <dd>{sessionEntity.station ? sessionEntity.station.id : ''}</dd>
          <dt>
            <Translate contentKey="cabmanApp.session.operator">Operator</Translate>
          </dt>
          <dd>{sessionEntity.operator ? sessionEntity.operator.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/session" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/session/${sessionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SessionDetail;
